<ng-container #vcListMasterSearchWidget></ng-container>
<ng-template
             #tmplListMasterSearchWidget>
    <list-master-search-widget *ngIf="!!config" [config]="config"></list-master-search-widget>
</ng-template>